<template>
    <div>
        <modal-confirm :show="showConfirm" @onselect="confirmCb">
            <div>{{ confirmMsg }}</div>
        </modal-confirm>
        <div>
            <label-entry :shop-info="shopInfo" @onadd="onAddCatLabel" :show-info-cats="showInfoCats"></label-entry>
        </div>

        <div>
            <div class="col-xs-12">
                <div v-for="bigCatG in labels" style="margin:4px;">
                    <span class="btn btn-default" style="float:left; font-weight:bolder;"
                        @click="showBigCatLabel(bigCatG)">
                        {{ bigCatG.category.name }}
                    </span>
                </div>
            </div>
        </div>

        <div v-if="bigCatGrp !== null" style="margin:4px;">
            <div>
                <div class="col-xs-12">
                    <h3 style="font-weight:bolder;">
                        {{ bigCatGrp.category.name }}
                    </h3>
                </div>

                <div class="col-xs-12" v-for="subCatGrp in bigCatGrp.items">
                    <span class="label label-info">{{ subCatGrp.category.name }}</span>

                    <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;" v-for="label in subCatGrp.items">
                        <div style="font-weight:bolder;"> {{ bigCatGrp.category.name }}/{{ subCatGrp.category.name }}</div>

                        <label-entry-tpl :shop-info="shopInfo" :new-label="label"
                            :label-type="shopLabelConfigs[subCatGrp.category.catId].label.label" :api-client="{
                                getUserFilesPrms: apiClient.getUserFilesPrms,
                                uploadFilePrms: apiClient.uploadFilePrms,
                                getShopInfoLabelByCatIdPrms: apiClient.getShopInfoLabelByCatIdPrms
                            }" v-on:onUpdateConfirm="updateCatLabel">
                        </label-entry-tpl>



                        <div class="col-xs-12" style="text-align:right;">
                            <input type="button" class="btn btn-primary" @click="updateCatLabel(label)"
                                value="Update" />
                            <input type="button" class="btn btn-primary" @click="deleteCatLabel(label, subCatGrp)"
                                value="Delete" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import apis from '../api/extApi.js';
import modalConfirm from './ModalConfirm.vue';
import labelEntry from './labelEntry.vue';
import labelEntryTpl from './labelEntryTpl.vue';

export default {
    components: {
        labelEntryTpl: labelEntryTpl,
        labelEntry: labelEntry,
        modalConfirm: modalConfirm
    },
    props: ["shopInfo"],
    computed: {
        lang: function () {
            return this.$store.getters.lang;
        }
    },
    data: function () {
        return {
            labels: null,
            shopLabelConfigs: null,
            apiClient: apis.api,
            uiClient: apis.ui,
            bigCatGrp: null,
            confirmMsg: null,
            showConfirm: false,
            confirmHandler: null,
            showInfoCats:false
        };
    },
    methods: {
        confirmCb: function (ok) {
            this.showConfirm = false;
            console.log("confirm e:", ok);
            if (this.confirmHandler !== null) {
                this.confirmHandler(ok);
            }
        },
        addCatLabel: function (label) {
            label.userId = this.shopInfo.shopUserId;
            this.apiClient.addShopCatLabelPrms(label).done((ret) => {
                if (ret.ok === true) {
                    this.loadlabels(label.catPair.parent.catId);
                }
            });
        },
        onAddCatLabel: function (newLabel) {
            console.log('newLabel', newLabel);
            this.addCatLabel(newLabel);
        },
        showBigCatLabel: function (bigCatGroup) {
            this.bigCatGrp = bigCatGroup;
        },
        loadlabels: function (bigCatId) {
            var that = this;
            that.apiClient.getShopInfoLabelsPrms().done(function (configsRet) {
                that.shopLabelConfigs = configsRet;
                that.apiClient.getShopCatLabelsGroupedPrms(that.shopInfo.shopUserId).done(function (ret) {
                    that.labels = ret;
                    that.showInfoCats = !(ret!==null && ret.length>0);
                    that.setSelectedBigCatLabel(bigCatId);
                });
            });
        },
        deleteCatLabel: function (label, grp) {
            this.showConfirm = true;
            this.confirmMsg = "Confirm Delete?";
            this.confirmHandler = (ok) => {
                if (!ok) return;
                this.apiClient.removeShopCatLabelPrms(label).done(function (ret) {
                    if (ret === true) {
                        grp.items = grp.items.filter(function (lb) {
                            return lb.id !== label.id;
                        });
                    }
                });
            }
        },
        updateCatLabel: function (label, item) {
            this.showConfirm = true;
            this.confirmMsg = "Confirm Update?";
            this.confirmHandler = (ok) => {
                if (!ok) return;
                this.isSelectingImage = false;
                if (item) {
                    label.label = item.fileName + item.fileType;
                }
                this.apiClient.updateShopCatLabelPrms(label).done(function (ret) {
                    if (ret.ok === true) {
                        var newLabel = ret.value;
                        for (var n in newLabel) {
                            label[n] = newLabel[n];
                        }
                    }
                });
            }
        },
        setSelectedBigCatLabel: function (bigCatId) {
            var hasLabels = this.labels !== null && this.labels.length > 0;
            this.bigCatGrp = null;
            if (typeof (bigCatId) === "undefined") {
                if (hasLabels) {
                    this.bigCatGrp = this.labels[0];
                }
                return;
            }
            if (hasLabels) {
                for (var i = 0; i < this.labels.length; i++) {
                    var lb = this.labels[i];
                    if (lb.category.catId === bigCatId) {
                        this.bigCatGrp = lb;
                        break;
                    }
                }
            }
        }
    },
    created: function () {

    },
    mounted: function () {
        this.loadlabels();
    }
}
</script>